export default [
  {
    release: '15.11',
    date: 'April 2023',
    contributors: [
      {
        name: 'Weyert de Boer',
        gitlabUsername: 'weyert-tapico',
      },
    ],
  },
  {
    release: '15.10',
    date: 'March 2023',
    contributors: [
      {
        name: 'Mohamed Mohamedin',
        gitlabUsername: 'mohamedin',
      },
    ],
  },
  {
    release: '15.9',
    date: 'February 2023',
    contributors: [
      {
        name: 'Kyle Edwards',
        gitlabUsername: 'KyleFromKitware',
      },
    ],
  },
  {
    release: '15.8',
    date: 'January 2023',
    contributors: [
      {
        name: 'Patrick Rice',
        gitlabUsername: 'PatrickRice',
      },
    ],
  },
  {
    release: '15.7',
    date: 'December 2022',
    contributors: [
      {
        name: 'Niklas van Schrick',
        gitlabUsername: 'Taucher2003',
      },
    ],
  },
  {
    release: '15.6',
    date: 'November 2022',
    contributors: [
      {
        name: 'Deja Norby',
        gitlabUsername: 'dlkeith90',
      },
    ],
  },
  {
    release: '15.5',
    date: 'October 2022',
    contributors: [
      {
        name: 'Anatoli Babenia',
        gitlabUsername: 'abitrolly',
      },
    ],
  },
  {
    release: '15.4',
    date: 'September 2022',
    contributors: [
      {
        name: 'Lennard Sprong',
        gitlabUsername: 'X_Sheep',
      },
    ],
  },
  {
    release: '15.3',
    date: 'August 2022',
    contributors: [
      {
        name: 'Marco Zille',
        gitlabUsername: 'zillemarco',
      },
    ],
  },
  {
    release: '15.2',
    date: 'July 2022',
    contributors: [
      {
        name: 'kyrie.31415926535',
        gitlabUsername: 'kyrie.31415926535',
      },
    ],
  },
  {
    release: '15.1',
    date: 'June 2022',
    contributors: [
      {
        name: 'feistel',
        gitlabUsername: 'feistel',
      },
    ],
  },
  {
    release: '15.0',
    date: 'May 2022',
    contributors: [
      {
        name: 'Lee Tickett',
        gitlabUsername: 'leetickett',
      },
    ],
  },
  {
    release: '14.10',
    date: 'April 2022',
    contributors: [
      {
        name: 'Jeremy Wu',
        gitlabUsername: 'JeremyWuuuuu',
      },
    ],
  },
  {
    release: '14.9',
    date: 'March 2022',
    contributors: [
      {
        name: 'Timo Furrer',
        gitlabUsername: 'tuxtimo',
      },
    ],
  },
  {
    release: '14.8',
    date: 'February 2022',
    contributors: [
      {
        name: 'Piotr Stankowski',
        gitlabUsername: 'trakos',
      },
    ],
  },
  {
    release: '14.7',
    date: 'January 2022',
    contributors: [
      {
        name: 'Fabio Huser',
        gitlabUsername: 'fh1ch',
      },
    ],
  },
  {
    release: '14.6',
    date: 'December 2021',
    contributors: [
      {
        name: 'Kev',
        gitlabUsername: 'KevSlashNull',
      },
    ],
  },
  {
    release: '14.5',
    date: 'November 2021',
    contributors: [
      {
        name: 'Jonas Wälter',
        gitlabUsername: 'wwwjon',
      },
    ],
  },
  {
    release: '14.4',
    date: 'October 2021',
    contributors: [
      {
        name: 'Ethan Reesor',
        gitlabUsername: 'firelizzard',
      },
    ],
  },
  {
    release: '14.3',
    date: 'September 2021',
    contributors: [
      {
        name: 'feistel',
        gitlabUsername: 'feistel',
      },
    ],
  },
  {
    release: '14.2',
    date: 'August 2021',
    contributors: [
      {
        name: 'Cornelius Ludmann',
        gitlabUsername: 'corneliusludmann',
      },
    ],
  },
  {
    release: '14.1',
    date: 'July 2021',
    contributors: [
      {
        name: 'Andrew Smith',
        gitlabUsername: 'espadav8',
      },
    ],
  },
  {
    release: '14.0',
    date: 'June 2021',
    contributors: [
      {
        name: 'Mathieu Parent',
        gitlabUsername: 'sathieu',
      },
    ],
  },
  {
    release: '13.12',
    date: 'May 2021',
    contributors: [
      {
        name: 'Lee Tickett',
        gitlabUsername: 'leetickett',
      },
    ],
  },
  {
    release: '13.11',
    date: 'April 2021',
    contributors: [
      {
        name: 'Yogi',
        gitlabUsername: 'yo',
      },
    ],
  },
  {
    release: '13.10',
    date: 'March 2021',
    contributors: [
      {
        name: 'Diego Louzán',
        gitlabUsername: 'dlouzan',
      },
    ],
  },
  {
    release: '13.9',
    date: 'February 2021',
    contributors: [
      {
        name: 'Andreas Gravgaard Andersen',
        gitlabUsername: 'agravgaard',
      },
    ],
  },
  {
    release: '13.8',
    date: 'January 2021',
    contributors: [
      {
        name: 'Yogi',
        gitlabUsername: 'yo',
      },
    ],
  },
  {
    release: '13.7',
    date: 'December 2020',
    contributors: [
      {
        name: 'Rachel Gottesman',
        gitlabUsername: 'gottesman.rachelg',
      },
    ],
  },
  {
    release: '13.6',
    date: 'November 2020',
    contributors: [
      {
        name: 'Sashi',
        gitlabUsername: 'ksashikumar',
      },
    ],
  },
  {
    release: '13.5',
    date: 'October 2020',
    contributors: [
      {
        name: 'Brian Williams (H-E-B Digital)',
        gitlabUsername: 'williams.brian-heb',
      },
    ],
  },
  {
    release: '13.4',
    date: 'September 2020',
    contributors: [
      {
        name: 'Fabio Huser',
        gitlabUsername: 'fh1ch',
      },
    ],
  },
  {
    release: '13.3',
    date: 'August 2020',
    contributors: [
      {
        name: 'Gilang Gumilar',
        gitlabUsername: 'gilangmlr',
      },
    ],
  },
  {
    release: '13.2',
    date: 'July 2020',
    contributors: [
      {
        name: 'Jesse Hall',
        gitlabUsername: 'jessehall3',
      },
    ],
  },
  {
    release: '13.1',
    date: 'June 2020',
    contributors: [
      {
        name: 'Jacopo Beschi',
        gitlabUsername: 'jacopo-beschi',
      },
    ],
  },
  {
    release: '13.0',
    date: 'May 2020',
    contributors: [
      {
        name: 'Sashi',
        gitlabUsername: 'ksashikumar',
      },
    ],
  },
  {
    release: '12.10',
    date: 'April 2020',
    contributors: [
      {
        name: 'Dmitry Chepurovskiy',
        gitlabUsername: 'dm3ch',
      },
    ],
  },
  {
    release: '12.9',
    date: 'March 2020',
    contributors: [
      {
        name: 'Steve Exley',
        gitlabUsername: 'steve.exley',
      },
    ],
  },
  {
    release: '12.8',
    date: 'February 2020',
    contributors: [
      {
        name: 'Roger Meier',
        gitlabUsername: 'bufferoverflow',
      },
    ],
  },
  {
    release: '12.7',
    date: 'January 2020',
    contributors: [
      {
        name: 'Fabio Huser',
        gitlabUsername: 'fh1ch',
      },
    ],
  },
  {
    release: '12.6',
    date: 'December 2019',
    contributors: [
      {
        name: 'Fabio Huser',
        gitlabUsername: 'fh1ch',
      },
    ],
  },
  {
    release: '12.5',
    date: 'November 2019',
    contributors: [
      {
        name: 'gfyoung',
        gitlabUsername: 'gfyoung',
      },
    ],
  },
  {
    release: '12.4',
    date: 'October 2019',
    contributors: [
      {
        name: 'Tuomo Ala-Vannesluoma',
        gitlabUsername: 'tuomoa',
      },
    ],
  },
  {
    release: '12.3',
    date: 'September 2019',
    contributors: [
      {
        name: 'Cédric Tabin',
        gitlabUsername: 'ctabin',
      },
    ],
  },
  {
    release: '12.2',
    date: 'August 2019',
    contributors: [
      {
        name: 'Fabio Papa',
        gitlabUsername: 'fapapa',
      },
    ],
  },
  {
    release: '12.1',
    date: 'July 2019',
    contributors: [
      {
        name: 'Guillaume Grossetie',
        gitlabUsername: 'g.grossetie',
      },
    ],
  },
  {
    release: '12.0',
    date: 'June 2019',
    contributors: [
      {
        name: 'Lumi Akimova',
        gitlabUsername: 'qwolphin',
      },
    ],
  },
  {
    release: '11.11',
    date: 'May 2019',
    contributors: [
      {
        name: 'Kia Mei Somabes',
        gitlabUsername: 'kiameisomabes',
      },
    ],
  },
  {
    release: '11.10',
    date: 'April 2019',
    contributors: [
      {
        name: 'Takuya Noguchi',
        gitlabUsername: 'tnir',
      },
    ],
  },
  {
    release: '11.9',
    date: 'March 2019',
    contributors: [
      {
        name: 'Marcel Amirault',
        gitlabUsername: 'Ravlen',
      },
    ],
  },
  {
    release: '11.8',
    date: 'February 2019',
    contributors: [
      {
        name: 'Aaron Walker',
        gitlabUsername: 'walkafwalka',
      },
    ],
  },
  {
    release: '11.7',
    date: 'January 2019',
    contributors: [
      {
        name: 'Morty Choi',
        gitlabUsername: 'mortyccp',
      },
    ],
  },
  {
    release: '11.6',
    date: 'December 2018',
    contributors: [
      {
        name: 'Suzanne Hillman',
        gitlabUsername: 'wispfox',
      },
    ],
  },
  {
    release: '11.5',
    date: 'November 2018',
    contributors: [
      {
        name: 'Tuomo Ala-Vannesluoma',
        gitlabUsername: 'tuomoa',
      },
    ],
  },
  {
    release: '11.4',
    date: 'October 2018',
    contributors: [
      {
        name: 'Luke Picciau',
        gitlabUsername: 'Qwertie',
      },
    ],
  },
  {
    release: '11.3',
    date: 'September 2018',
    contributors: [
      {
        name: 'George Tsiolis',
        gitlabUsername: 'gtsiolis',
      },
    ],
  },
  {
    release: '11.2',
    date: 'August 2018',
    contributors: [
      {
        name: 'JX Terry',
        gitlabUsername: 'jxterry',
      },
    ],
  },
  {
    release: '11.1',
    date: 'July 2018',
    contributors: [
      {
        name: 'Jasper Maes',
        gitlabUsername: 'jlemaes',
      },
    ],
  },
  {
    release: '11.0',
    date: 'June 2018',
    contributors: [
      {
        name: 'Vitaliy Klachkov',
        gitlabUsername: 'blackst0ne',
      },
    ],
  },
  {
    release: '10.8',
    date: 'May 2018',
    contributors: [
      {
        name: 'Alexis Reigel',
        gitlabUsername: 'koffeinfrei',
      },
    ],
  },
  {
    release: '10.7',
    date: 'April 2018',
    contributors: [
      {
        name: 'Rob Watson',
        gitlabUsername: 'rfwatson',
      },
    ],
  },
  {
    release: '10.6',
    date: 'March 2018',
    contributors: [
      {
        name: 'Takuya Noguchi',
        gitlabUsername: 'tnir',
      },
    ],
  },
  {
    release: '10.5',
    date: 'February 2018',
    contributors: [
      {
        name: 'Hiroyuki Sato',
        gitlabUsername: 'hiroponz',
      },
    ],
  },
  {
    release: '10.4',
    date: 'January 2018',
    contributors: [
      {
        name: 'George Tsiolis',
        gitlabUsername: 'gtsiolis',
      },
    ],
  },
  {
    release: '10.3',
    date: 'December 2017',
    contributors: [
      {
        name: 'Vitaliy Klachkov',
        gitlabUsername: 'blackst0ne',
      },
    ],
  },
  {
    release: '10.2',
    date: 'November 2017',
    contributors: [
      {
        name: 'Travis Miller',
        gitlabUsername: 'travismiller',
      },
    ],
  },
  {
    release: '10.1',
    date: 'October 2017',
    contributors: [
      {
        name: 'Vitaliy Klachkov',
        gitlabUsername: 'blackst0ne',
      },
    ],
  },
  {
    release: '10.0',
    date: 'September 2017',
    contributors: [
      {
        name: 'Hiroyuki Sato',
        gitlabUsername: 'hiroponz',
      },
    ],
  },
  {
    release: '9.5',
    date: 'August 2017',
    contributors: [
      {
        name: 'Alexis Reigel',
        gitlabUsername: 'koffeinfrei',
      },
    ],
  },
  {
    release: '9.4',
    date: 'July 2017',
    contributors: [
      {
        name: 'Matt Gresko',
        gitlabUsername: 'mgresko',
      },
    ],
  },
  {
    release: '9.3',
    date: 'June 2017',
    contributors: [
      {
        name: 'Huang Tao',
        gitlabUsername: 'htve',
      },
    ],
  },
  {
    release: '9.2',
    date: 'May 2017',
    contributors: [
      {
        name: 'Dosuken Shinya',
        gitlabUsername: 'dosuken123',
      },
    ],
  },
  {
    release: '9.1',
    date: 'April 2017',
    contributors: [
      {
        name: 'Maxim Rydkin',
        gitlabUsername: 'innerwhisper',
      },
    ],
  },
  {
    release: '9.0',
    date: 'March 2017',
    contributors: [
      {
        name: 'Jacopo Beschi',
        gitlabUsername: 'jacopo-beschi',
      },
    ],
  },
  {
    release: '8.17',
    date: 'February 2017',
    contributors: [
      {
        name: 'Horacio Sanson',
        gitlabUsername: 'Sanson',
      },
    ],
  },
  {
    release: '8.16',
    date: 'January 2017',
    contributors: [
      {
        name: 'Markus Koller',
        gitlabUsername: 'toupeira',
      },
    ],
  },
  {
    release: '8.15',
    date: 'December 2016',
    contributors: [
      {
        name: 'Michael Munch',
        gitlabUsername: 'Munken',
      },
    ],
  },
  {
    release: '8.14',
    date: 'November 2016',
    contributors: [
      {
        name: 'Toon Claes',
        gitlabUsername: 'to1ne',
      },
    ],
  },
  {
    release: '8.13',
    date: 'October 2016',
    contributors: [
      {
        name: 'Marc Siegfriedt',
        gitlabUsername: 'mahcsig',
      },
    ],
  },
  {
    release: '8.12',
    date: 'September 2016',
    contributors: [
      {
        name: 'James Munnelly',
        gitlabUsername: 'munnerz',
      },
    ],
  },
  {
    release: '8.11',
    date: 'August 2016',
    contributors: [
      {
        name: 'Clement Ho',
        gitlabUsername: 'ClemMakesApps',
      },
    ],
  },
  {
    release: '8.10',
    date: 'July 2016',
    contributors: [
      {
        name: 'Winnie',
        gitlabUsername: 'winniehell',
      },
    ],
  },
  {
    release: '8.9',
    date: 'June 2016',
    contributors: [
      {
        name: 'Rui Santos',
        gitlabUsername: 'ruianderson',
      },
    ],
  },
  {
    release: '8.8',
    date: 'May 2016',
    contributors: [
      {
        name: 'Matt Oakes',
        gitlabUsername: 'matt-oakes',
      },
    ],
  },
  {
    release: '8.7',
    date: 'April 2016',
    contributors: [
      {
        name: 'Connor Shea',
        gitlabUsername: 'connorshea',
      },
    ],
  },
  {
    release: '8.6',
    date: 'March 2016',
    contributors: [
      {
        name: 'Marcia Ramos',
        gitlabUsername: 'marcia',
      },
    ],
  },
  {
    release: '8.5',
    date: 'February 2016',
    contributors: [
      {
        name: 'Artem Sidorenko',
        gitlabUsername: 'artem-sidorenko',
      },
    ],
  },
  {
    release: '8.4',
    date: 'January 2016',
    contributors: [
      {
        name: 'Kyungchul Shin',
        gitlabUsername: 'koreamic',
      },
    ],
  },
  {
    release: '8.3',
    date: 'December 2015',
    contributors: [
      {
        name: 'Greg Smethells',
        gitlabUsername: 'gsmethells',
      },
    ],
  },
  {
    release: '8.2',
    date: 'November 2015',
    contributors: [
      {
        name: 'Cristian Bica',
        gitlabUsername: 'cristianbica',
      },
    ],
  },
  {
    release: '8.1',
    date: 'October 2015',
    contributors: [
      {
        name: 'Zeger-Jan van de Weg',
        gitlabUsername: 'zj',
      },
    ],
  },
  {
    release: '8.0',
    date: 'September 2015',
    contributors: [
      {
        name: 'Kirill Zaitsev',
        gitlabUsername: 'bugagazavr',
      },
    ],
  },
  {
    release: '7.14',
    date: 'August 2015',
    contributors: [
      {
        name: 'Stan Hu',
        gitlabUsername: 'stanhu',
      },
    ],
  },
  {
    release: '7.13',
    date: 'July 2015',
    contributors: [
      {
        name: 'Stan Hu',
        gitlabUsername: 'stanhu',
      },
    ],
  },
  {
    release: '7.12',
    date: 'June 2015',
    contributors: [
      {
        name: 'Alexandre Lossent (CERN)',
        gitlabUsername: 'cernvcs',
      },
    ],
  },
  {
    release: '7.11',
    date: 'May 2015',
    contributors: [
      {
        name: 'James Newton',
        gitlabUsername: 'newton',
      },
    ],
  },
  {
    release: '7.10',
    date: 'April 2015',
    contributors: [
      {
        name: 'Stan Hu',
        gitlabUsername: 'stanhu',
      },
    ],
  },
  {
    release: '7.9',
    date: 'March 2015',
    contributors: [
      {
        name: 'Stan Hu',
        gitlabUsername: 'stanhu',
      },
    ],
  },
  {
    release: '7.8',
    date: 'February 2015',
    contributors: [
      {
        name: 'Hannes Rosenögger',
        gitlabUsername: 'haynes',
      },
    ],
  },
  {
    release: '7.7',
    date: 'January 2015',
    contributors: [
      {
        name: 'Ciro Santilli',
        gitlabUsername: 'cirosantilli',
      },
    ],
  },
  {
    release: '7.6',
    date: 'December 2014',
    contributors: [
      {
        name: 'Ben Bodenmiller',
        gitlabUsername: 'bbodenmiller',
      },
    ],
  },
  {
    release: '7.5',
    date: 'November 2014',
    contributors: [
      {
        name: 'Martijn van Bemmel',
        gitlabUsername: 'mvb',
      },
    ],
  },
  {
    release: '7.4',
    date: 'October 2014',
    contributors: [
      {
        name: 'Vinnie Okada',
        gitlabUsername: 'mr-vinn',
      },
    ],
  },
  {
    release: '7.3',
    date: 'September 2014',
    contributors: [
      {
        name: 'Robert Schilling',
        gitlabUsername: 'razer6',
      },
    ],
  },
  {
    release: '7.2',
    date: 'August 2014',
    contributors: [
      {
        name: 'Robert Schilling',
        gitlabUsername: 'razer6',
      },
    ],
  },
  {
    release: '7.1',
    date: 'July 2014',
    contributors: [
      {
        name: 'Jeroen van Baarsen',
        gitlabUsername: 'jvanbaarsen',
      },
    ],
  },
  {
    release: '7.0',
    date: 'June 2014',
    contributors: [
      {
        name: 'Earle Randolph Bunao',
      },
      {
        name: 'Neil Francis Calabroso',
      },
    ],
  },
  {
    release: '6.9',
    date: 'May 2014',
    contributors: [
      {
        name: 'Evgeniy Sokovikov',
        gitlabUsername: 'skv-headless',
      },
    ],
  },
  {
    release: '6.8',
    date: 'April 2014',
    contributors: [
      {
        name: 'Jeroen van Baarsen',
        gitlabUsername: 'jvanbaarsen',
      },
    ],
  },
  {
    release: '6.7',
    date: 'March 2014',
    contributors: [
      {
        name: 'Jason Hollingsworth',
        gitlabUsername: 'jhworth.developer',
      },
    ],
  },
  {
    release: '6.6',
    date: 'February 2014',
    contributors: [
      {
        name: 'Drew Blessing',
        gitlabUsername: 'dblessing',
      },
    ],
  },
  {
    release: '6.5',
    date: 'January 2014',
    contributors: [
      {
        name: 'Jason Blanchard',
        gitlabUsername: 'jas.blanchard',
      },
    ],
  },
  {
    release: '6.4',
    date: 'December 2013',
    contributors: [
      {
        name: 'Steven Thonus',
        gitlabUsername: 'StevenT',
      },
      {
        name: 'Jason Hollingsworth',
        gitlabUsername: 'jhworth.developer',
      },
    ],
  },
  {
    release: '6.3',
    date: 'November 2013',
    contributors: [
      {
        name: 'Andrew Kumanyaev',
        gitlabUsername: 'zzet',
      },
    ],
  },
  {
    release: '6.2',
    date: 'October 2013',
    contributors: [
      {
        name: 'Steven Thonus',
        gitlabUsername: 'StevenT',
      },
    ],
  },
  {
    release: '6.1',
    date: 'September 2013',
    contributors: [
      {
        name: 'Ash Wilson',
        gitlabUsername: 'smashwilson',
      },
    ],
  },
  {
    release: '6.0',
    date: 'August 2013',
    contributors: [
      {
        name: 'Izaak Alpert',
        gitlabUsername: 'ialpert',
      },
    ],
  },
  {
    release: '5.4',
    date: 'July 2013',
    contributors: [
      {
        name: 'Javier Castro',
        gitlabUsername: 'jadark',
      },
    ],
  },
  {
    release: '5.3',
    date: 'June 2013',
    contributors: [
      {
        name: 'Karlo Nicholas T. Soriano',
        gitlabUsername: 'karloxyz',
      },
    ],
  },
  {
    release: '5.2',
    date: 'May 2013',
    contributors: [
      {
        name: 'Angus MacArthur',
        gitlabUsername: 'amacarthur',
      },
    ],
  },
  {
    release: '5.1',
    date: 'April 2013',
    contributors: [
      {
        name: 'Hiroyuki Sato',
        gitlabUsername: 'hiroponz',
      },
    ],
  },
  {
    release: '5.0',
    date: 'March 2013',
    contributors: [
      {
        name: 'Dan Knox',
        gitlabUsername: 'DanKnox',
      },
    ],
  },
];
